import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { colors, spacing } = theme;

const iconSize = {
  width: 15,
  height: 15,
};

export default createUseStyles(
  {
    root: {
      display: 'flex',
      cursor: 'pointer',
      userSelect: 'none',
      marginBottom: spacing.sp02,
      color: colors.textPrimary,

      '&:focus': {
        outline: 'none',
      },
    },

    input: {
      display: 'none',
    },

    checkboxWrap: {
      height: 20,
      display: 'flex',
      alignItems: 'center',
    },

    unchecked: {
      ...iconSize,
    },

    checkbox: {
      ...iconSize,
      position: 'relative',
      zIndex: 2,
      flexShrink: 0,
      flexGrow: 0,
      boxSizing: 'border-box',
      transition: 'all .2s',
      overflow: 'hidden',

      '$root$checked &': {
        color: colors.iconLink,
      },

      '$root$checked$disabled &': {
        color: 'transparent',
      },
    },

    disabled: {
      pointerEvents: 'none',
      color: colors.textDisabled,

      '& $icon': {
        color: colors.iconDisabled,
      },
    },

    nested: {
      marginLeft: '28px',
    },

    label: {
      marginLeft: 11,
    },

    icon: {
      ...iconSize,
      zIndex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      boxSizing: 'border-box',
      color: colors.iconLink,
    },
  },
  {
    name: 'Checkbox',
  },
);
